import { React, useState, useRef } from "react";
import ContactPopup from "../ContactPopup";
// import "./ServicePage.css";
import "../ImportExport/ServicePages.css";
import { Helmet } from "react-helmet";

const Section8Closure = () => {

  const [openPopup, setOpenPopup] = useState(false);

  const contactRef = useRef(null);

  const scrollToContact = () => {
    contactRef.current?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="service-page">

      {/* SEO */}
      <Helmet>
        <title>Section 8 Company Closure | NGO Closure Service India</title>
        <meta
          name="description"
          content="Close your Section 8 Company legally with ROC approval. Expert assistance for strike off, winding up, and NGO compliance closure in India."
        />
        <meta
          name="keywords"
          content="Section 8 Company Closure, NGO Closure India, Strike Off Section 8, Winding Up NGO, ROC Closure Service"
        />
      </Helmet>

      {/* HERO */}
      <div className="service-hero">
        <h1>Section 8 Company Closure Service</h1>
        <p>Non-Profit Company Closure Assistance in India</p>
        <button className="hero-btn" onClick={scrollToContact} >
          Get Started Today
        </button>

      </div>

      {/* OVERVIEW */}
      <div className="service-section">
        <h2>Overview</h2>
        <p>
          A Section 8 Company is a non-profit organization formed for charitable,
          educational, or social objectives under the Companies Act, 2013.
        </p>
        <p>
          Closing a Section 8 Company requires proper legal compliance and approval
          from ROC and sometimes the Central Government.
        </p>
      </div>

      {/* METHODS */}
      <div className="service-section">
        <h2>Methods of Closing a Section 8 Company</h2>

        <div className="card">
          <h3>Strike Off (Fast Track Closure)</h3>
          <ul>
            <li>No business activity</li>
            <li>No assets or liabilities</li>
            <li>No active funding/donations</li>
            <li>Members agree to close</li>
          </ul>
        </div>

        <div className="card">
          <h3>Voluntary Winding Up</h3>
          <ul>
            <li>Company has assets or liabilities</li>
            <li>Funds need settlement</li>
            <li>Formal dissolution required</li>
          </ul>
        </div>
      </div>

      {/* SPECIAL REQUIREMENT */}
      <div className="service-section">
        <h2>Special Requirement</h2>
        <p>
          Section 8 Companies may require approval from the Regional Director or
          Central Government before closure.
        </p>
      </div>

      {/* SERVICES */}
      <div className="service-section">
        <h2>Our Services Include</h2>
        <ul>
          <li>Eligibility assessment</li>
          <li>STK-2 filing</li>
          <li>Board & Special Resolutions</li>
          <li>Regulatory approval assistance</li>
          <li>ROC compliance clearance</li>
          <li>GST & Income Tax deregistration</li>
          <li>Bank account closure support</li>
        </ul>
      </div>

      {/* WHEN TO CLOSE */}
      <div className="service-section">
        <h2>When Should You Close?</h2>
        <ul>
          <li>Objectives not active</li>
          <li>No funding or donations</li>
          <li>Inactive organization</li>
          <li>Restructuring NGO</li>
        </ul>
      </div>

      {/* DOCUMENTS */}
      <div className="service-section">
        <h2>Documents Required</h2>
        <ul>
          <li>Certificate of Incorporation</li>
          <li>PAN Card</li>
          <li>MOA & AOA</li>
          <li>Financial statements</li>
          <li>Bank closure proof</li>
          <li>Board resolutions</li>
          <li>Director ID proof</li>
        </ul>
      </div>

      {/* BENEFITS */}
      <div className="service-section">
        <h2>Benefits of Proper Closure</h2>
        <ul>
          <li>Legal compliance</li>
          <li>Avoid penalties</li>
          <li>Clean closure record</li>
          <li>No future filings</li>
        </ul>
      </div>
 <div className="cta" ref={contactRef}>

        <h2>Close Your Section 8 Company Smoothly</h2>

        <p>
          Let our experts manage the complete closure process
          with full legal compliance and accuracy.
        </p>

        <div className="cta-buttons">

          <button onClick={() => setOpenPopup(true)}>
            Contact Us Now
          </button>

          <ContactPopup
            isOpen={openPopup}
            onClose={() => setOpenPopup(false)}
          />

          <button
            className="outline"
            onClick={() =>
              (window.location.href = "tel:9218103915")
            }
          >
            Free Consultation
          </button>

        </div>
      </div>

    </div>
  );
};

export default Section8Closure;